<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { Button } from '@pkg/sanity-utils/types/button';
import type { ModularBlock } from '@pkg/sanity-utils/types/modularContentBlocks';
import { THEME } from '@pkg/config/misc/theme';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    theme: THEME;
    anchorId?: string;
    content: Array<ModularBlock>;
    buttons: Array<Button>;
  };
  config: {
    innerComponent?: Component;
  };
}>();

// Block theme should only be a light or dark color
const theme = computed(() => {
  if (props.block?.theme === THEME.LIGHT_ALT) {
    return THEME.LIGHT;
  }

  if (props.block?.theme === THEME.DARK_ALT) {
    return THEME.DARK;
  }

  return props.block?.theme;
})

const data = computed(() => ({
  theme: theme.value,
  content: props.block?.content,
  buttons: props.block?.buttons,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data"/>
</template>
